export const documentReportInitialValues = {
  empresas: [],
  linhas: [],
  tiposServico: [],
  tiposDocumento: [],
  dtCadastro: { dtInicio: '', dtFim: '' },
};
